import React from 'react';

export default function MyTeam() {

    return (
        <div className="text-center py-5">
            MyTeam
        </div>
    )
}